import React from 'react';

const About = () => {
    return (
        <div>
            <h1>I am about page</h1>
        </div>
    );
};

export default About;